import styled from 'styled-components';

export const MenuContainer = styled.div`
    position: relative;
`;

export const MenuButton = styled.button`
    background: transparent;
    border: none;
    color: #B6C2CF;
    padding: 8px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    &:active {
        background: rgba(255, 255, 255, 0.2);
    }
`;

export const MenuDropdown = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    min-width: 200px;
    z-index: 1000;
    overflow: hidden;
`;

export const MenuItem = styled.button`
    width: 100%;
    padding: 8px 12px;
    background: none;
    border: none;
    color: ${props => props.isDelete ? '#FF5630' : '#B6C2CF'};
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;

    &:hover {
        background: #3B444C;
    }

    &:active {
        background: #465059;
    }
`;